import * as React from 'react'
import Dropzone from 'react-dropzone';
import { PulseLoader } from 'react-spinners';
import { toastr } from "react-redux-toastr";
import InputContainer from 'src/modules/AdHocTools/VisualSearch/components/InputContainer';
import ImageErrorContainer from 'src/modules/AdHocTools/VisualSearch/components/ImageErrorContainer';
import { readFileAsDataURL } from 'src/share/utils/fileHandler';
import "./ImageUploader.css";

interface IImageUploaderProps {
  thumbnail: string;
  isLoading: boolean;
  onDropAccepted: (image: string) => void;
  onImageRemoved: () => void;
}

const ImageUploader = (props: IImageUploaderProps): React.ReactElement => {
  const [imageName, setImageName] = React.useState("");
  const [error, setError] = React.useState("");
  const fileInputRef: React.MutableRefObject<HTMLInputElement | undefined> = React.useRef();
  React.useEffect(() => {
    if(!props.thumbnail) {
      setImageName("");
    } 
  }, [props.thumbnail]);
  function handleImageUploaded(): void {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  }
  function handleImageRemoved(): void {
    setImageName("");
    setError("");
    props.onImageRemoved();
  }
  async function handleDropAccepted(files): Promise<void> {
    const file = files[0];
    const base64 = await readFileAsDataURL(file, (result) => {
      return (result.target && result.target.result) || "";
    });
    setImageName(file.name);
    setError("");
    props.onDropAccepted(base64);
  }
  function handleImageRejected(): void {
    setError("Invalid file format.");
    toastr.error("Invalid file format", "You can only upload images.");
  }
  function getImageDescription(): React.ReactElement {
    if (error) {
      return <ImageErrorContainer error={error} />
    }
    if (props.isLoading) {
      return <PulseLoader loading={props.isLoading} color={"#00353b"} sizeUnit={"px"} size={10} />;
    }
    return <InputContainer handleDropAccepted={handleDropAccepted} fileInputRef={fileInputRef} />
  }
  return (
    <div className={`image-uploader ${error ? "error" : ""}`} >
      {imageName &&
        <div className="image-uploader__header">
          <p className="input-label">{imageName}</p>
          <span className="fa fa-times" aria-hidden="true" onClick={handleImageRemoved}/>
        </div>}
      <div className="drop-zone-container" onClick={handleImageUploaded} style={{ height: imageName ? '80%' : '100%' }}>
        <Dropzone
          className="drop-zone-fluid"
          activeClassName="active"
          multiple={false}
          accept="image/jpeg, image/png"
          onDropAccepted={handleDropAccepted}
          onDropRejected={handleImageRejected}
        >
          {props.thumbnail ? <img src={props.thumbnail} alt="Searched Image" /> : <span className="fa fa-paperclip fa-2x" aria-hidden="true" />}
        </Dropzone>
        {getImageDescription()}
      </div>
    </div>
  )
}

export default React.memo(ImageUploader);
